var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _g5, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackageInteractiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -15,
    y: -15,
    width: 109,
    height: 109
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(7.5px)",
      clipPath: "url(#bgblur_0_54568_50335_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 15
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39,
    stroke: "url(#paint0_radial_54568_50335)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39,
    stroke: "url(#paint1_radial_54568_50335)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -15,
    y: -15,
    width: 109,
    height: 109
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(7.5px)",
      clipPath: "url(#bgblur_1_54568_50335_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 15
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39,
    fill: "url(#paint2_radial_54568_50335)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39,
    stroke: "url(#paint3_radial_54568_50335)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39,
    stroke: "url(#paint4_radial_54568_50335)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_54568_50335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9039 64.6584C58.9083 66.4601 56.7011 68.0009 54.3507 69.2355C51.5308 70.7186 48.5052 71.7599 45.4194 72.3221C42.3328 72.8871 39.1928 72.9714 36.1378 72.5946C33.0796 72.227 30.097 71.3994 27.3338 70.1504C25.9463 69.5394 24.624 68.7987 23.362 67.9849L22.8908 67.6766L22.6558 67.5224L22.4277 67.3574L21.5187 66.6979C20.9333 66.2308 20.3433 65.7748 19.7939 65.2704L19.376 64.9007C19.3053 64.8406 19.24 64.774 19.1729 64.7095L18.9729 64.5152L18.5737 64.1268L18.3746 63.9328C18.3416 63.9002 18.3077 63.8687 18.2757 63.8352L18.1805 63.7336L17.4222 62.9216L17.3277 62.8202L17.2375 62.7148L17.0579 62.5033L16.6995 62.0808L16.5208 61.8698C16.4613 61.7994 16.4007 61.7301 16.3458 61.6558L16.0083 61.2175C15.7858 60.9238 15.5533 60.6394 15.3491 60.3326C15.1397 60.0302 14.928 59.7306 14.7224 59.4273L14.1388 58.4957L13.994 58.2629L13.8595 58.0236L13.5911 57.5455L13.3237 57.0684L13.0782 56.5793L12.8344 56.0905L12.7128 55.8464C12.6714 55.7656 12.638 55.6805 12.6003 55.5978L12.1619 54.6004C11.6135 53.256 11.1626 51.8806 10.8093 50.4867C10.4742 49.0868 10.2427 47.6712 10.1049 46.2531C9.98429 44.832 9.97295 43.4107 10.044 42.0009C10.1446 43.4108 10.3277 44.8065 10.6142 46.1765C10.918 47.5434 11.3096 48.8823 11.7932 50.1814C12.2952 51.4747 12.883 52.7257 13.5519 53.9249L14.0774 54.8097C14.1221 54.8826 14.1624 54.958 14.2107 55.029L14.3526 55.2432L14.6358 55.6711L14.919 56.0976L15.2222 56.5105L15.5246 56.9225L15.6753 57.1282L15.8359 57.327L16.4778 58.1188C16.7014 58.3745 16.9298 58.6256 17.1545 58.8784C17.3739 59.1357 17.6203 59.3698 17.8552 59.6123L18.2101 59.9731C18.2678 60.0344 18.331 60.0907 18.393 60.148L18.579 60.3196L18.9502 60.6624L19.1354 60.8335L19.2282 60.9188L19.3251 60.9998L20.0973 61.6471L20.1935 61.7279C20.2258 61.7544 20.2601 61.7789 20.2933 61.8046L20.4937 61.9567L20.8937 62.2605L21.0933 62.4123C21.16 62.4624 21.2249 62.5148 21.2951 62.5607L21.7086 62.8442C22.2506 63.2334 22.8263 63.5724 23.3901 63.9214L24.2613 64.4031L24.4782 64.5234L24.7014 64.6329L25.1468 64.8517C26.3363 65.4267 27.5563 65.9272 28.8107 66.3032C31.3089 67.0819 33.9006 67.4617 36.4688 67.4541C39.0392 67.4557 41.5835 67.0639 43.9796 66.3108C46.3778 65.5597 48.6336 64.4491 50.6558 63.0424C52.2295 61.9488 53.6607 60.6764 54.9177 59.2688L52.5 57.5009L63 56.5009V66.3108L60.9039 64.6584Z",
    fill: "url(#paint5_linear_54568_50335)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_54568_50335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0961 16.1658C20.0917 14.3641 22.2989 12.8233 24.6493 11.5887C27.4692 10.1056 30.4948 9.06432 33.5806 8.50209C36.6672 7.93711 39.8072 7.85282 42.8622 8.22961C45.9204 8.59724 48.903 9.42486 51.6662 10.6738C53.0537 11.2848 54.376 12.0255 55.638 12.8393L56.1092 13.1476L56.3442 13.3018L56.5723 13.4668L57.4813 14.1263C58.0667 14.5934 58.6567 15.0494 59.2061 15.5538L59.624 15.9235C59.6947 15.9836 59.76 16.0502 59.8271 16.1147L60.0271 16.309L60.4263 16.6974L60.6254 16.8914C60.6584 16.924 60.6923 16.9555 60.7243 16.989L60.8195 17.0906L61.5778 17.9026L61.6723 18.004L61.7625 18.1095L61.9421 18.3209L62.3005 18.7434L62.4792 18.9544C62.5387 19.0248 62.5993 19.0941 62.6542 19.1684L62.9917 19.6067C63.2142 19.9004 63.4467 20.1849 63.6509 20.4916C63.8603 20.794 64.072 21.0936 64.2776 21.397L64.8612 22.3286L65.006 22.5613L65.1405 22.8006L65.4089 23.2787L65.6763 23.7559L65.9218 24.245L66.1656 24.7337L66.2872 24.9778C66.3286 25.0586 66.362 25.1437 66.3997 25.2264L66.8381 26.2238C67.3865 27.5682 67.8374 28.9436 68.1907 30.3375C68.5258 31.7374 68.7573 33.153 68.8951 34.5711C69.0157 35.9922 69.027 37.4135 68.956 38.8233C68.8554 37.4134 68.6723 36.0177 68.3858 34.6477C68.082 33.2808 67.6904 31.9419 67.2068 30.6428C66.7048 29.3495 66.117 28.0985 65.4481 26.8993L64.9226 26.0145C64.8779 25.9416 64.8376 25.8662 64.7893 25.7953L64.6474 25.581L64.3642 25.1531L64.081 24.7267L63.7778 24.3138L63.4754 23.9017L63.3247 23.696L63.1641 23.4972L62.5222 22.7054C62.2986 22.4497 62.0702 22.1987 61.8455 21.9458C61.6261 21.6885 61.3797 21.4544 61.1448 21.2119L60.7899 20.8511C60.7322 20.7898 60.669 20.7335 60.607 20.6762L60.421 20.5046L60.0498 20.1619L59.8646 19.9907L59.7718 19.9055L59.6749 19.8244L58.9027 19.1771L58.8065 19.0963C58.7742 19.0698 58.7399 19.0453 58.7067 19.0196L58.5063 18.8676L58.1063 18.5637L57.9067 18.412C57.84 18.3618 57.7751 18.3094 57.7049 18.2635L57.2914 17.98C56.7494 17.5908 56.1737 17.2518 55.6099 16.9028L54.7387 16.4211L54.5218 16.3008L54.2986 16.1913L53.8532 15.9725C52.6637 15.3975 51.4437 14.897 50.1893 14.521C47.6911 13.7423 45.0994 13.3626 42.5312 13.3701C39.9608 13.3686 37.4165 13.7604 35.0204 14.5134C32.6222 15.2645 30.3664 16.3752 28.3442 17.7819C26.7705 18.8754 25.3393 20.1478 24.0823 21.5554L26.5 23.3233L16 24.3233V14.5134L18.0961 16.1658Z",
    fill: "url(#paint6_linear_54568_50335)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1149 37.3164V40.0727C27.0211 39.6352 25.9329 39.1977 24.8391 38.7602C25.9329 38.2789 27.0211 37.7977 28.1149 37.3164Z",
    fill: "#FFBC1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1719 38.7586C50.8977 39.2672 49.618 39.7812 48.3438 40.2898V37.0742C49.618 37.6375 50.8977 38.1953 52.1719 38.7586Z",
    fill: "#FFBC1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6943 45.7748C47.4301 46.6884 46.4096 47.1439 45.5463 46.7335L34.0322 41.2599C33.3418 40.9317 32.989 40.1522 33.2003 39.4215L38.6976 20.4112C38.9618 19.4976 39.9823 19.0421 40.8456 19.4525L52.3598 24.926C53.0502 25.2542 53.4029 26.0337 53.1916 26.7644L47.6943 45.7748Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8662 48.1615C45.602 49.0751 44.5815 49.5306 43.7182 49.1202L32.2041 43.6467C31.5136 43.3184 31.1609 42.5389 31.3722 41.8083L36.8695 22.7979C37.1337 21.8843 38.1542 21.4288 39.0175 21.8392L50.5316 27.3127C51.2221 27.641 51.5748 28.4205 51.3635 29.1511L45.8662 48.1615Z",
    fill: "#C5BED6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9807 50.3842C43.7165 51.2978 42.696 51.7533 41.8327 51.3429L30.3186 45.8693C29.6281 45.5411 29.2754 44.7616 29.4867 44.0309L34.984 25.0205C35.2482 24.1069 36.2687 23.6515 37.132 24.0619L48.6461 29.5354C49.3366 29.8636 49.6893 30.6431 49.478 31.3738L43.9807 50.3842Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0832 52.474C41.819 53.3876 40.7985 53.8431 39.9352 53.4327L28.4211 47.9592C27.7307 47.6309 27.378 46.8514 27.5893 46.1208L33.0866 27.1104C33.3508 26.1968 34.3713 25.7413 35.2345 26.1517L46.7487 31.6252C47.4391 31.9535 47.7918 32.733 47.5805 33.4636L42.0832 52.474Z",
    fill: "#C5BED6"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_54568_50335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9853 36.7692C42.4959 37.0395 42.7523 37.6266 42.6033 38.1849L38.6248 53.0967C38.4209 53.8609 37.5635 54.2415 36.86 53.8802L26.1846 48.3968C25.6656 48.1302 25.4026 47.5378 25.553 46.974L29.5332 32.0562C29.7355 31.298 30.5824 30.9159 31.2848 31.2661L32.4826 31.8634C33.1855 32.2139 34.0331 31.8309 34.2346 31.0717L34.5191 29.9998C34.7222 29.2345 35.5806 28.853 36.2848 29.215L39.1641 30.6954C39.6816 30.9615 39.9445 31.5516 39.7962 32.1143L39.2384 34.2309C39.0916 34.7883 39.3481 35.3734 39.8575 35.643L41.9853 36.7692Z",
    fill: "url(#paint7_linear_54568_50335)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 59.5391V44.2266C39.7797 45.6867 41.0576 47.1451 42.3336 48.6016C45.6094 47.0977 48.8888 45.5938 52.1719 44.0898V52.9766C47.6164 55.1641 43.0591 57.3516 38.5 59.5391Z",
    fill: "#FFBD18"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 44.2281V59.5406C33.9445 57.3531 29.3872 55.1656 24.8281 52.9781V44.0859C28.1094 45.5953 31.3906 47.101 34.6719 48.6031C35.9461 47.143 37.2221 45.6846 38.5 44.2281ZM36.3125 55.1656V52.4313C35.3992 52.0648 34.4914 51.7039 33.5781 51.3375V54.0719C34.4914 54.4383 35.3992 54.7992 36.3125 55.1656Z",
    fill: "#F7CC61"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3125 52.4297V55.1641C35.3992 54.7977 34.4914 54.4367 33.5781 54.0703V51.3359C34.4914 51.7023 35.3992 52.0633 36.3125 52.4297Z",
    fill: "#636A74"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1148 40.0703C31.0297 41.2352 33.9445 42.4018 36.8594 43.5703L38.5 44.2266C37.2258 45.6867 35.9497 47.1451 34.6719 48.6016C31.3906 47.0977 28.1094 45.5919 24.8281 44.0844C23.7344 43.5812 22.6406 43.0836 21.5469 42.5805C22.6461 41.3062 23.7435 40.032 24.8391 38.7578C25.9328 39.1953 27.0211 39.6328 28.1148 40.0703Z",
    fill: "#F3D894"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1407 56.8039C40.0148 56.8039 39.8927 56.7604 39.7951 56.6808C39.6976 56.6011 39.6304 56.4903 39.6051 56.3669C39.5798 56.2436 39.5979 56.1152 39.6563 56.0036C39.7146 55.892 39.8097 55.804 39.9255 55.7544L43.7536 54.1138C43.8868 54.0572 44.037 54.0558 44.1713 54.1098C44.3055 54.1638 44.4129 54.2688 44.4699 54.4018C44.5268 54.5348 44.5287 54.685 44.4752 54.8194C44.4216 54.9538 44.3169 55.0615 44.1841 55.1189L40.3559 56.7595C40.288 56.789 40.2147 56.8041 40.1407 56.8039Z",
    fill: "#F4A811"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1407 54.6164C40.0148 54.6164 39.8927 54.5729 39.7951 54.4933C39.6976 54.4136 39.6304 54.3028 39.6051 54.1794C39.5798 54.0561 39.5979 53.9277 39.6563 53.8161C39.7146 53.7045 39.8097 53.6165 39.9255 53.5669L43.7536 51.9263C43.8868 51.8697 44.037 51.8683 44.1713 51.9223C44.3055 51.9763 44.4129 52.0813 44.4699 52.2143C44.5268 52.3473 44.5287 52.4975 44.4752 52.6319C44.4216 52.7663 44.3169 52.874 44.1841 52.9314L40.3559 54.572C40.288 54.6015 40.2147 54.6166 40.1407 54.6164Z",
    fill: "#F4A811"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7812 42.9141L48.3438 40.2891C49.618 39.7805 50.8977 39.2664 52.1719 38.7578C53.2656 40.032 54.3594 41.3081 55.4531 42.5859C54.3594 43.0891 53.2656 43.5904 52.1719 44.0898C48.8906 45.5938 45.6112 47.0977 42.3336 48.6016C41.0539 47.1414 39.776 45.6831 38.5 44.2266L41.7812 42.9141Z",
    fill: "#FCD572"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_54568_50335_clip_path",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_54568_50335_clip_path",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 39
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_54568_50335",
    x: 10,
    y: 41.5,
    width: 53,
    height: 31.3242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.831373 0 0 0 0 0.564706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_54568_50335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_54568_50335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_54568_50335",
    x: 16,
    y: 8,
    width: 53,
    height: 31.3242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.741176 0 0 0 0 0.129412 0 0 0 0 0.117647 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_54568_50335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_54568_50335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_54568_50335",
    x: 21.7906,
    y: 26.9079,
    width: 25.8151,
    height: 33.6222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.620059,
    dy: 2.17021
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.17021
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.321296 0 0 0 0 0.234017 0 0 0 0 0.504167 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_54568_50335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_54568_50335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_54568_50335",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(63.4987 57.5792 -57.5792 175.774 -10.8664 -9.76791)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_54568_50335",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-59.5847 -63.7484 63.7484 -164.939 85.5404 88.9393)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#307FE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_54568_50335",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(79.8259 55.3113 -19.4882 114.507 3.5 32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44218A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494363,
    stopColor: "#4176DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AA6F3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_54568_50335",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(63.4987 57.5792 -57.5792 175.774 -10.8664 -9.76791)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_54568_50335",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-59.5847 -63.7484 63.7484 -164.939 85.5404 88.9393)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#307FE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_54568_50335",
    x1: 11,
    y1: 49.5009,
    x2: 66,
    y2: 58.5009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FADF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEAB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_54568_50335",
    x1: 69.0247,
    y1: 36.5,
    x2: 16.8899,
    y2: 20.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7B78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_54568_50335",
    x1: 41.7517,
    y1: 32.3819,
    x2: 32.1746,
    y2: 59.3292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageInteractiveIcon);
export default __webpack_public_path__ + "static/media/packageInteractiveIcon.be00eace6264572eed1810c15559d88d.svg";
export { ForwardRef as ReactComponent };